/**
 * @deprecated We are moving from the use of `categories` and `rulesets` to a unified set of
 * categories. `ConstituentCategories` should be used moving forward unless legacy usage is
 * needed. Legacy usage of `categories` and `rulesets` should use
 * `LegacyConstituentCategories` and `LegacyConstituentRules`, respectively.
 */
enum LegacyConstituentRules {
  IS_DONOR_RULESET = 'is_donor_ruleset',
  IS_MAJOR_DONOR_RULESET = 'is_major_donor_ruleset',
  IS_RECURRING_DONOR_RULESET = 'is_recurring_donor_ruleset',
}

export default LegacyConstituentRules;
